import {withJsonFormsControlProps} from '@jsonforms/react'
import SimpleButtonControl from './SimpleButtonControl'
export default withJsonFormsControlProps(SimpleButtonControl)
